import React from "react";

class PdfPlaceholder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSize: 7,
    };
    this.textRef = null;
  }

  componentDidMount() {
    this.adjustFontSize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.setState({ fontSize: 7 }, () => this.adjustFontSize());
    }
  }

  adjustFontSize() {
    if (this.textRef && this.props.language) {
      const bbox = this.textRef.getBBox();
      const maxWidth = 36; // width inside black box (40 - padding)

      if (bbox.width > maxWidth) {
        const scale = maxWidth / bbox.width;
        this.setState({ fontSize: this.state.fontSize * scale });
      }
    }
  }

  render() {
    const { language } = this.props;
    const { fontSize } = this.state;

    const words = language ? language.split(" ") : [];
    const isTwoLine = words.length > 1;
    const adjustedFontSize = isTwoLine ? fontSize * 0.75 : fontSize; // much smaller for 2 lines

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.dynamicWidth ? "100%" : "150"}
          height="150"
          viewBox="0 0 64 64"
        >
          {/* Document shape */}
          <rect
            x="12"
            y="8"
            width="40"
            height="48"
            rx="2"
            ry="2"
            fill="black"
            stroke="#3fa9f5"
            strokeWidth="2"
          />

          {/* Folded corner */}
          <polygon points="40,8 52,8 52,20" fill="#3fa9f5" />

          {/* Upload arrow */}
          <path
            d="M32 34 L32 18 M24 24 L32 16 L40 24"
            stroke="#3fa9f5"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* PDF label */}
          <text
            x="32"
            y="44"
            textAnchor="middle"
            fontSize="8"
            fill="#3fa9f5"
            fontWeight="bold"
          >
            PDF
          </text>

          {/* Language label */}
          {language &&
            (isTwoLine ? (
              <text
                ref={(el) => (this.textRef = el)}
                x="32"
                y="50" // slight downshift
                textAnchor="middle"
                fontSize={adjustedFontSize}
                fill="white"
              >
                <tspan x="32" dy="0">
                  {words[0].toUpperCase()}
                </tspan>
                <tspan x="32" dy="4">
                  {words.slice(1).join(" ").toUpperCase()}
                </tspan>
              </text>
            ) : (
              <text
                ref={(el) => (this.textRef = el)}
                x="32"
                y="53"
                textAnchor="middle"
                fontSize={adjustedFontSize}
                fill="white"
              >
                {language.toUpperCase()}
              </text>
            ))}
        </svg>
      </div>
    );
  }
}

export default PdfPlaceholder;
